// checks if the user is authorized to edit the wiki
export default async function wikiGuard(to, from, next, store) {

    // Check if the wiki articles have already been loaded
    if (to.matched.some((record) => record.meta.requiresWikiFetch) && !store.getters['wiki/hasLoaded']) {
        await store.dispatch('wiki/fetchArticles');
    }
}
